<template>
    <div>
        <h4 style="color: #9618D3;text-align: center;margin-top: 50px;">{{ sponsorTitle }}</h4>
        <h5>一、广告服务</h5>
        <h5 style="font-weight: normal;margin-left: 10px;">以下价格均含制作与安装（印刷广告除外）</h5>
        <div class="row" >
            <div class="col-lg-12">
                <img src="@/assets/images/img/exhibitionOverview/advertising.png">
            </div>
        </div>
        <h5 style="margin-top: 30px;">二、赞助方案</h5>
        <div style="margin: 0px;display: flex">
            <h5 style="color: #333;">1.赞助条件:</h5>
            <h5 style="font-weight: normal;margin-left: 10px;">必须是国内或国际品牌企业，在业界具有极高知名度和美誉度的，并拥有业界领先技术水平的产品</h5>
        </div>
        <div style="margin: 0px;display: flex">
            <h5 style="color: #333;">2.博览会冠名:</h5>
            <h5 style="font-weight: normal;margin-left: 10px;">100万元（独家）</h5>
        </div>
        <div style="margin: 0px;display: flex">
            <h5 style="color: #333;">3.晚会冠名:</h5>
            <h5 style="font-weight: normal;margin-left: 10px;">50万（限一家企业）</h5>
        </div>
        <div style="margin: 0px;display: flex">
            <h5 style="color: #333;">4.协办单位冠名:</h5>
            <h5 style="font-weight: normal;margin-left: 10px;">30万（限8家）</h5>
        </div>
    </div>
</template>

<script>
import expo from "../../config/expo";

export default {
  name: "Sponsor",
  data() {
    return {
      sponsorTitle: expo.sponsorTitle
    }
  }
}
</script>
